import { render, staticRenderFns } from "./SlideShowDisplay.vue?vue&type=template&id=8a189eb4&scoped=true&"
import script from "./SlideShowDisplay.vue?vue&type=script&lang=js&"
export * from "./SlideShowDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowDisplay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SlideShowDisplay.vue?vue&type=style&index=1&id=8a189eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a189eb4",
  null
  
)

export default component.exports